import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

// import $ from "jquery";
const { REACT_APP_CDN_HOST: CDN_HOST } = process.env;

const mapStateToProps = ({ identity }) => ({
  identity
});
class OfficeLayoutHead extends Component {
  modalMessage = () => {
    this.setState({
      isModalMessage: !this.state.isModalMessage
    });
  };

  renderAvatar() {
    const {
      identity: { profile }
    } = this.props;
    const src =
      profile && profile.image
        ? `${CDN_HOST}/${profile.image}`
        : "/images/icon-inst.png";
    return (
      <img
        alt="Аватар"
        ref="avatar"
        className="image-form"
        src={src}
        onError={() =>
          Object.assign(this.refs.avatar, {
            src: "/images/icon-inst.png",
            onerror: ""
          })
        }
      />
    );
  }

  render() {
    const { REACT_APP_AUTH_HOST, REACT_APP_DOMAIN } = process.env;
    const logoutUrl = `${REACT_APP_AUTH_HOST}/logout?redirect-url=//${REACT_APP_DOMAIN}`;
    const { identity } = this.props;
    return (
      <div className="office-header">
        <div className="container header-container">
          <div>
            {/* <div className="containerModalMessage">
              <div id="dialog" className="btn-header btn-border-white">
                <span className="icon">
                  <img src="/images/icon-mail.png" alt="" />
                </span>
              </div>
            </div> */}
          </div>
          <div className="dropdown">
            <a
              className="btn btn-secondary dropdown-toggle btn-header btn-border-white"
              role="button"
              id="dropdownMenuLink"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              Мой кабинет
            </a>

            <div
              className="dropdown-menu"
              aria-labelledby="dropdownMenuLink"
              style={{ marginTop: 10 + "px" }}
            >
              <div id="dropdown-menu-name-and-city">
                <div id="dropdown-menu-name">
                  {identity.name}
                  <br />
                </div>
                <div id="dropdown-menu-city">
                  {(identity.city && identity.city.name) || ""}
                </div>
              </div>

              <div className="dropdown-centre">
                {this.renderAvatar()}
                <div className="menu-form-user">
                  <div className="link-a">
                    <Link to="/account">
                      <span className="buttons-menu-dropdown">
                        Данные пользователя
                      </span>
                    </Link>
                  </div>
                  {identity.theatreId && (
                    <div className="link-a">
                      <Link to="/theatre">
                        <span className="buttons-menu-dropdown">
                          Данные кинотеатра
                        </span>
                      </Link>
                    </div>
                  )}

                  <div className="link-a">
                    <Link to="/change-password">
                      <i className="fas fa-cogs" />
                      <span className="buttons-menu-dropdown">
                        &nbsp;Сменить пароль
                      </span>
                    </Link>
                  </div>
                  <br />
                  <a href={logoutUrl} className="btn btn-gradient text-center">
                    выйти
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps)(OfficeLayoutHead);



// WEBPACK FOOTER //
// ./src/containers/layout/_officeHead.jsx